/**
 * Action filters
 *
 * Keep in mind that actions filters are complex, and this isn't the only component that renders them. Make sure you
 * check how changes to methods that return TemplateResults will affect action filters inside loops.
 */

// Import dependencies
import { AutomatorActionFilterBase } from './_base';
import { unsafeCSS, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';

// Import style for web component
import styles from './web-component-style.scss?inline';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-log-filter' )
export class AutomatorActionFilter extends AutomatorActionFilterBase {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;
}
